<template>
    <div>
    <input type="text" autocomplete="off" :value="patient_name" name="patient_name" v-on:blur="blurHandler"  v-on:keyup="onchangeHandler" class="form-control" placeholder="Input Patient Name">
    <input autocomplete="off" name="item_id" type="hidden" >
    <div class="suggestion_capsule" >
        <div  v-for="option in options" :key="option.id">
            <article @click='optionclick(option)' class='borderit spacer'>

                <span class='min_dull spacer'> {{ option.name.toUpperCase() }}  </span><br/>
                <span class='more_info spacer'> {{ option.opd+" - ID No: "+option.id_number +" - Phone No: "+option.phone }}  </span>
            
            </article>
        </div>
        
    </div>
</div>
</template>

<script>

import { generalApiRequest } from "../../../api/apiIndex";


export default {
    name:"patientInput",
    data() {
    return {
         patient_name:"",
        options:[],
        picked :{}
       
    };
},

props: {
    Store_id:{
      type: Number,
    //   required: true
    },
   PassedPatientName:{
      type: String,
    //   required: true
    },

  },

  components: {
    // Itemname,
  },

methods:{
  
    async onchangeHandler(event){
        this[event.target.name]= event.target.value;
        const url = 'searchSpecificCompanyUsers'; 
        const body = {search_param : event.target.value};
        const suggestions = await generalApiRequest(url, 'GET', body, 1);
        this.picked ={};
        // console.log("expose");next_of_kin
        this.options = suggestions;
    },
   
    optionclick(option) {
        var nm = option.name;
// console.log(option);
        this.patient_name = nm;
        this.picked = option;
        this.$emit('patientoption-check', this.picked);
    },

    blurHandler(){
        setTimeout(() => {
         this.options = [];
         if (Object.keys(this.picked).length === 0) {
            this.$emit('patientoption-check', {name:this.patient_name}); 
         }
            
        }, 500);
        
        // const myElement = this.$refs["itemSuggestions"+row]; 
        //   if (myElement) {
        //       const newContent = document.createElement('div');
        //        newContent.innerHTML = ``;

        //        if (myElement.firstChild) {
        //           myElement.replaceChild(newContent, myElement.firstChild);
        //        }else{
        //          myElement.appendChild(newContent);
        //         }
        //   } 

    },

},

mounted() {
    // console.log(this.Store_id);
    this.patient_name = this.PassedPatientName;
  },

}

</script>

<style scoped>
.suggestion_capsule{
    border: 1px solid grey;
    border-radius: 0.2em;
    z-index: 7;
    position: absolute;
    background-color: rgb(231, 238, 238);
    max-height: 50vh;
    overflow-x: auto;
    /* padding-right: 1em; */
}
.spacer{
    padding-right: 1em;
    padding-left: 1em;
}
.min_dull{
    font-size: 1.0em;
    color:black;
}



.borderit{
    border-bottom: 1px solid rgb(184, 212, 216) !important;
    cursor: pointer;
    /* background-color: brown; */

}

.borderit:hover {
  background-color: beige; /* Color on hover */
  /* animation: fadeIn 1s ease-in-out; Animation triggered on hover */
  transform: scale(1.1); /* Apply animation on hover */
  border: 1px solid green !important;
}
.more_info{
    font-size: 0.8em;
    color: rgb(131, 128, 128);
}
</style>